var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17285 14.5C1.04785 14.5 0.172852 13.625 0.172852 12.5V2.5C0.172852 1.40625 1.04785 0.5 2.17285 0.5H12.1729C13.2666 0.5 14.1729 1.40625 14.1729 2.5V12.5C14.1729 13.625 13.2666 14.5 12.1729 14.5H2.17285ZM10.1729 11.5C10.7041 11.5 11.1729 11.0625 11.1729 10.5V4.5C11.1729 3.96875 10.7041 3.5 10.1729 3.5C9.61035 3.5 9.17285 3.96875 9.17285 4.5V10.5C9.17285 11.0625 9.61035 11.5 10.1729 11.5ZM8.17285 4.5C8.17285 3.96875 7.7041 3.5 7.17285 3.5C6.61035 3.5 6.17285 3.96875 6.17285 4.5V6.5C6.17285 7.0625 6.61035 7.5 7.17285 7.5C7.7041 7.5 8.17285 7.0625 8.17285 6.5V4.5ZM4.17285 9.5C4.7041 9.5 5.17285 9.0625 5.17285 8.5V4.5C5.17285 3.96875 4.7041 3.5 4.17285 3.5C3.61035 3.5 3.17285 3.96875 3.17285 4.5V8.5C3.17285 9.0625 3.61035 9.5 4.17285 9.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.032e11d0.svg";
export { ForwardRef as ReactComponent };